import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import DropdownList from 'react-widgets/lib/DropdownList';

class DefinedDropdownField extends Component {
  constructor(props) {
    super(props);

    this.getItemComponent = this.getItemComponent.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
  }

  handleOnChange(data) {
    const { valueField, valueFieldFn, name, change, formId } = this.props;
    if (typeof valueField === 'string') {
      change(formId, name, data[valueField]);
      return;
    }

    if (typeof valueFieldFn === 'function') {
      const value = valueFieldFn(data);
      change(formId, name, value);
      return;
    }

    change(formId, name, data);
  }

  handleOnBlur() {
    const { input } = this.props;
    input.onBlur();
  }

  getItemComponent(data) {
    return data.text || '';
  }

  render() {
    const {
      input,
      valueField = 'id',
      textField = 'name',
      groupBy,
      data,
      filter,
      label,
      meta,
      required,
    } = this.props;

    const { touched, error } = meta || {};
    const showError = touched && error ? 'error' : '';
    const requiredLabel = required ? 'required' : '';

    return (
      <div className={`${requiredLabel} field ${showError}`}>
        {label && <label>{label}</label>}

        <DropdownList
          {...input}
          data={data}
          filter={filter}
          valueField={valueField}
          textField={textField}
          groupBy={groupBy}
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    name: ownProps.input.name,
  };
}
DefinedDropdownField = connect(mapStateToProps, {
  change,
})(DefinedDropdownField);
export default DefinedDropdownField;
